/**
 * Experiment variant assignment persistence (T-164-002 — batch 4 S10).
 *
 * The variant schema/persistence is owned by buffy (B5) server-side; this FE
 * module only READS the assignment the platform has already decided. When the
 * user is bucketed for an experiment, the assignment is written to
 * localStorage under `lp_exp_variant_<experimentId>`; if absent the variant is
 * "unsplit" (null) and events still fire without a bucket so the admin
 * significance calculator ignores unassigned traffic.
 */

export const EXP_VARIANT_KEY_PREFIX = 'lp_exp_variant_';

export function variantKey(experimentId: string): string {
  return `${EXP_VARIANT_KEY_PREFIX}${experimentId}`;
}

/** Read the assigned variant for an experiment ("control" / "treatment" / …). */
export function getAssignedVariant(experimentId: string): string | null {
  try {
    return localStorage.getItem(variantKey(experimentId));
  } catch {
    return null;
  }
}

/** Bucket the user into a variant (used by tests + platform integration). */
export function setAssignedVariant(experimentId: string, variant: string): void {
  try {
    localStorage.setItem(variantKey(experimentId), variant);
  } catch {
    /* ignore */
  }
}

export function clearAssignedVariant(experimentId: string): void {
  try {
    localStorage.removeItem(variantKey(experimentId));
  } catch {
    /* ignore */
  }
}